export const ADD_LOADING = "ADD_LOADING";
export const ADD_MATERIAL = "ADD_MATERIAL";
export const MATERIAL_FAILURE = "MATERIAL_FAILURE";
export const MATERIAL_SUCCESS = "MATERIAL_SUCCESS";
export const MATERIAL_ERROR = "MATERIAL_ERROR";
export const GET_MATERIAL = "GET_MATERIAL";
export const GET_STORE = "GET_STORE";
export const STORE_FAILURE = "STORE_ERROR";
export const STORE_SUCCESS = "MATERIAL_SUCCESS";
